import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;
export default function ReinFlowFooter() {
	return <Footer style={{ textAlign: 'center' }}>ReinFlow Traffic Platform ©2020 Created by Team ReinFlow</Footer>;
}
